import { render } from "./WidgetRendererEditorCmp.vue?vue&type=template&id=1e49fd72"
import script from "./WidgetRendererEditorCmp.vue?vue&type=script&lang=js"
export * from "./WidgetRendererEditorCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__